import React from "react";
import { FooterBottomSheet } from "~/screens/Component/FooterBottomSheet";

interface FooterBottomSheetContextType {
  footerBottomSheetRef: React.RefObject<FooterBottomSheet>;
}

export const FooterBottomSheetContext = React.createContext<FooterBottomSheetContextType | null>(null);
